// extracted by mini-css-extract-plugin
export default {"container":"map_device_container__MDwwC"};